import type { TypeConfig } from '../../common/types.tsx';
import { BETWEEN_CONFIG } from './between-config.tsx';
import { BETWEEN_DATE_TIME_CONFIG } from './between-date-time-config.tsx';
import { DUE_IN_NEXT_CONFIG } from './due-in-next-config.tsx';
import { IN_RANGE_CONFIG } from './in-range-config.tsx';
import { MORE_THAN_CONFIG, CONFIG_DATE_MORE_THAN } from './more-than-config.tsx';
import { NOW_OVERDUE_CONFIG } from './now-overdue-config.tsx';
import { WITHIN_THE_LAST_CONFIG } from './within-the-last-config.tsx';

export const DueDateTypeConfig: TypeConfig[] = [
	NOW_OVERDUE_CONFIG,
	MORE_THAN_CONFIG,
	DUE_IN_NEXT_CONFIG,
	BETWEEN_CONFIG,
	IN_RANGE_CONFIG,
];

export const DateTypeConfig: TypeConfig[] = [
	WITHIN_THE_LAST_CONFIG,
	CONFIG_DATE_MORE_THAN,
	BETWEEN_CONFIG,
	IN_RANGE_CONFIG,
];

export const DateTimeTypeConfig: TypeConfig[] = [
	WITHIN_THE_LAST_CONFIG,
	CONFIG_DATE_MORE_THAN,
	BETWEEN_DATE_TIME_CONFIG,
	IN_RANGE_CONFIG,
];
